"use strict";
// Copyright © 2024 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RandomImageModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomImageModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_slicksort_1 = require("vue-slicksort");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const Image_contracts_1 = require("../Image/Image.contracts");
let RandomImageModuleForm = RandomImageModuleForm_1 = class RandomImageModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.initialContent = RandomImageModuleForm_1.getInitialContent();
        this.resolvedImages = [];
    }
    forceOnUpdate() {
        this.$forceUpdate();
    }
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.RandomImage,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false,
                minColSpan: 6,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    static getInitialContent() {
        return {
            images: []
        };
    }
    mounted() {
        this.resolveImages();
    }
    onAddNewImageBtnClick() {
        this.pickRelated(services_1.Picker.Media, this.addImage);
    }
    addImage(source) {
        const newImage = {
            action: Image_contracts_1.FileDataActions.None,
            useAsAd: false,
            hideDescription: false,
            hideAuthor: false,
            weight: '1',
            image: source
        };
        this._content.images = [...this._content.images, newImage];
        this.resolveImages();
    }
    deleteImage(index) {
        const imagesCopy = [...this._content.images];
        imagesCopy.splice(index, 1);
        this._content.images = imagesCopy;
        this.resolvedImages.splice(index, 1);
    }
    async resolveImages() {
        this.resolvedImages = [];
        await Promise.all(this._content.images.map((imageItem, index) => {
            return new Promise((resolve, reject) => {
                this.relatedService
                    .resolve(imageItem.image, {})
                    .then((resolvedImage) => {
                    if (Object.prototype.hasOwnProperty.call(resolvedImage, 'file')) {
                        this.resolvedImages[index] = {
                            type: resolvedImage.file.type,
                            thumbnail: resolvedImage.url
                        };
                    }
                    else if (Object.prototype.hasOwnProperty.call(resolvedImage, 'url')) {
                        this.resolvedImages[index] = {
                            type: backoffice_1.ImageType.JPG,
                            thumbnail: resolvedImage.url
                        };
                    }
                    if (Object.prototype.hasOwnProperty.call(resolvedImage, 'caption')) {
                        this.resolvedImages[index].caption = resolvedImage.caption;
                    }
                    resolve();
                })
                    .catch((e) => {
                    console.warn(e);
                    reject(e);
                });
            });
        }));
        this.$forceUpdate();
    }
    hasRelatedLink(imageItem) {
        return !!(imageItem.redirect && typeof imageItem.redirect !== 'string' &&
            typeof imageItem.redirect.value !== 'undefined' && typeof imageItem.redirect.type !== 'undefined');
    }
    findLinkSource(index) {
        this.pickRelated(services_1.Picker.Content, (source) => {
            this.setLinkSource(index, source);
        });
    }
    setLinkSource(index, source) {
        const imagesCopy = [...this._content.images];
        imagesCopy[index].redirect = source;
        this._content.images = imagesCopy;
        this.$nextTick(() => {
            this.describe(source);
        });
    }
    deleteLinkSource(index) {
        const imagesCopy = [...this._content.images];
        delete imagesCopy[index].redirect;
        this._content.images = imagesCopy;
    }
    isImageResolved(index) {
        return !!this.resolvedImages[index];
    }
};
RandomImageModuleForm = RandomImageModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'RandomImageModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            SlickList: vue_slicksort_1.SlickList,
            SlickItem: vue_slicksort_1.SlickItem
        },
        template: `
    <div class="random-image-module-form">
      <SlickList :value="_content.images" v-model="_content.images"
                 axis="y" lockAxis="y" tag="ol" :distance="50"
                 class="draggable__list p-0 list-unstyled" appendTo=".draggable__list"
                 helperClass="shadow">
        <SlickItem v-for="(imageItem, index) in _content.images" :key="index"
                   :index="index" tag="li" class="bg-light p-3 mb-3">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-6">
                <figure v-if="isImageResolved(index)"
                        class="bg-body p-3 figure-with-btn__image-container mt-4">
                  <DashmixFile :file="resolvedImages[index]"
                               class="mb-3"/>
                  <figcaption>{{ resolvedImages[index].caption }}</figcaption>
                  <DashmixButton class="figure-with-btn__delete-btn"
                                 size="small" variant="icon" :icon="icons.TrashSolid" theme="danger"
                                 @click="deleteImage(index)"/>
                </figure>
              </div>
              <div class="col-12 col-md-6">
                <DashmixCheck class="pb-3" :label="$t('forms.image.useAsAd')" :name="'useAsAd_' + index"
                              :model.sync="imageItem.useAsAd" @update:model="forceOnUpdate"/>
                <DashmixCheck class="pb-3" :label="$t('forms.image.hideDescription')" :name="'hideDescription_' + index"
                              :model.sync="imageItem.hideDescription" @update:model="forceOnUpdate"/>
                <DashmixCheck class="pb-3" :label="$t('forms.image.hideAuthor')" :name="'hideAuthor_' + index"
                              :model.sync="imageItem.hideAuthor" @update:model="forceOnUpdate"/>
                <label :for="'weight_' + index" class="d-block">{{ $t('forms.randomImage.weight') }}</label>
                <DashmixInput class="mb-3" :name="'weight_' + index" :model.sync="imageItem.weight" @update:model="forceOnUpdate"/>
                <DashmixCheck class="pb-3" :label="$t('forms.image.hasExternalLink')" :name="'hasExternalLink_' + index"
                              :model.sync="imageItem.hasExternalLink" @update:model="forceOnUpdate"/>
                <template v-if="imageItem.hasExternalLink">
                  <div class="form-group">
                    <label for="urlPath" class="d-block">{{ $t('forms.image.path.label') }}</label>
                    <DashmixInput :model.sync="imageItem.redirectExt" :name="'urlPath_' + index"
                                  :placeholder="$t('forms.image.path.placeholder')" @update:model="forceOnUpdate"/>
                  </div>
                </template>
                <template v-else>
                  <DashmixButton v-if="!hasRelatedLink(imageItem)" variant="alt" :icon="icons.SearchSolid"
                                 :label="$t('forms.shared.search')"
                                 @click="findLinkSource(index)"/>
                  <div class="row" v-else>
                    <div class="col d-flex align-items-center">
                      <p class="mb-0">
                        <strong class="mr-2">{{ $t('forms.shared.chosenSource') }}</strong>
                        {{ description(imageItem.redirect) }}
                      </p>
                    </div>
                    <div class="col-3 d-flex text-right">
                      <DashmixButton variant="icon" :icon="icons.PenSolid"
                                     @click="findLinkSource(index)"/>
                      <DashmixButton theme="danger" variant="icon"
                                     :icon="icons.TrashSolid"
                                     @click="deleteLinkSource(index)"/>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </SlickItem>
      </SlickList>
      <DashmixButton variant="icon" :icon="icons.PlusSolid"
                     :label="$t('forms.randomImage.addNewImage')" @click="onAddNewImageBtnClick"/>
    </div>
  `
    })
], RandomImageModuleForm);
exports.RandomImageModuleForm = RandomImageModuleForm;
//# sourceMappingURL=RandomImage.form.js.map